import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../../service'
import useDebouncedValue from '../../../../../../hooks/useDebounceValue'

export const useGetReportObjectPreview = (body = {}, options = {}) => {
  const { mapper = null, enabled = true } = options ?? {}

  const debouncedBody = useDebouncedValue(body ?? {}, 1000)
  return useQuery({
    queryKey: ['reports', 'getReportObjectPreview', debouncedBody],
    queryFn: async () => {
      const { data } = await postNamedQuery('reports', 'get-report-object-preview', debouncedBody)
      if (data.status === 'processing') {
        for (let i = 0; i < 10; i++) {
          await new Promise(resolve => setTimeout(resolve, 1000 * Math.pow(1.5, i)))
          const { data } = await postNamedQuery('reports', 'get-report-object-preview', debouncedBody)
          if (data.status !== 'processing') {
            return data
          }
        }
      }
      return data
    },
    enabled,
    mapper: mapper ?? ((data) => data?.data ?? [])
  })
}
